import { Module } from '../../../ts/Module';
import { CheckboxState } from './CheckboxState';

interface ICheckboxTristateScope extends ng.IScope {
  state: () => string;
  toggle?: () => void;
  click: () => void;
}

/*
 * Tri-state version of custom checkbox control.  See tbCheckbox.ts for the dual-state checkbox.
 */
Module.instance().directive('tbCheckboxTristate',
  () => {
    return {
      restrict: 'E',
      replace: true,
      require: '?ngModel',
      templateUrl: 'checkboxTristate.html',
      scope: {
        state: '&',
        click: '&'
      },
      link: (scope: ICheckboxTristateScope, elm: JQuery, attrs: ng.IAttributes, ctrl: ng.INgModelController) => {

        scope.toggle = () => {
          // do nothing if disabled
          if (elm.hasClass('tb-disabled')) return;
          if (ctrl) {
            ctrl.$setViewValue(CheckboxState.toggle(ctrl.$viewValue));
            ctrl.$render();
          }
          scope.click();
        };

        if (ctrl) {
          scope.state = () => ctrl.$viewValue;
        }
      }
    };
  }
);
